import { PathsElement } from '@swagger-api/apidom-ns-openapi-3-0';

/**
 * @public
 */
class Paths extends PathsElement {}
export default Paths;